// extracted by mini-css-extract-plugin
export default {"title":"confirm_title__qvcTA","text":"confirm_text__RKy46","btn_container":"confirm_btn_container__b-5Wu","btn_styles":"confirm_btn_styles__1BnOB"};